import { useTheme } from '@emotion/react';
import { Attention } from '@icon-park/react';
import type { QueryObserverResult, RefetchOptions } from '@tanstack/react-query';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import type request from 'superagent';

import type { ActivitySummary } from '@didaskill/domain/reporting/types';
import { Button, Card, Typography } from '@didaskill/ui/design-system';
import { globalMessages } from '@didaskill/ui/intl';

import messages from './StreaksCalendarError.messages';
import * as styles from './StreaksCalendarError.styles';

type StreaksCalendarErrorProps = {
  refetch: (
    options?: RefetchOptions,
  ) => Promise<QueryObserverResult<ActivitySummary, request.ResponseError>>;
  onClose: () => void;
};

const StreaksCalendarErrorBase = ({ refetch, onClose }: StreaksCalendarErrorProps) => {
  const theme = useTheme();
  return (
    <Card css={styles.cardContainer}>
      <Card.Body css={styles.cardTitle}>
        <Attention size={20} fill={[theme.colors.warning[500], theme.colors.gray[0]]} />

        <div css={styles.cardContent}>
          <Typography variant={Typography.VARIANTS.HEADING_4}>
            <FormattedMessage {...messages.TITLE} />
          </Typography>

          <Typography variant={Typography.VARIANTS.BODY_MEDIUM_REGULAR}>
            <FormattedMessage
              {...messages.BODY}
              values={{
                b: (chunks) => (
                  <Typography variant={Typography.VARIANTS.BODY_MEDIUM_BOLD}>{chunks}</Typography>
                ),
              }}
            />
          </Typography>
        </div>
      </Card.Body>

      <Card.Footer variant={Card.VARIANTS.WARNING} css={styles.cardFooter}>
        <Button onClick={onClose}>
          <FormattedMessage {...globalMessages.IGNORE} />
        </Button>

        <Button variant={Button.VARIANTS.WARNING} onClick={() => refetch()}>
          <FormattedMessage {...globalMessages.RETRY} />
        </Button>
      </Card.Footer>
    </Card>
  );
};

StreaksCalendarErrorBase.displayName = 'StreaksCalendarError';

export const StreaksCalendarError = memo(StreaksCalendarErrorBase);
